import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ButtonModule } from '@sitemule/ng-components/components/button';
import { ContainerModule } from '@sitemule/ng-components/components/container';
import { SvgIconModule } from '@sitemule/ng-components/directives/svg-icon';
import { NgxTypedJsModule } from 'ngx-typed-js';
import { Frame3Module } from 'src/app/app-frames/frame-3/frame-3.module';
import { BackgroundScrollAnimatorModule } from 'src/app/components/background-scroll-animator/background-scroll-animator.module';
import { CustomerDemandModule } from 'src/app/components/customers-demand/demand.module';
import { CustomersModule } from 'src/app/components/customers/customers.module';
import { StretchableTextModule } from 'src/app/components/stretchable-text/stretchable-text.module';
import { TechnicalModule } from 'src/app/components/technical/technical.module';
import { WebBasedServiceModule } from 'src/app/components/web-based-service/web-based.module';
import { YoutubeModalModule } from 'src/app/components/youtube-modal/youtube-modal.module';
import { FaviconModule } from 'src/app/directives/favicon/favicon.module';
import { SneakPeakModule } from 'src/app/directives/sneak-peak/sneak-peak.module';
import { TitleModule } from 'src/app/directives/title/title.module';
import { ContactFormModule } from 'src/app/shared/components/contact-form/contact-form.module';
import { ImageAnimationModule } from 'src/app/shared/components/image-animation/image-animation.module';
import { PersonsModule } from 'src/app/shared/components/persons-contact/team.module';
import { SitemuleSolutionsComponent } from './solutions.component';

const routes: Routes = [
  {
    path: '',
    component: SitemuleSolutionsComponent
  },
];

@NgModule({
  declarations: [SitemuleSolutionsComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    Frame3Module,
    TitleModule,

    TechnicalModule,
    WebBasedServiceModule,
    FaviconModule,
    SvgIconModule,
    CustomerDemandModule,
    CustomersModule,
    BackgroundScrollAnimatorModule,
    NgxTypedJsModule,
    ContainerModule,
    PersonsModule,
    ContactFormModule,
    SneakPeakModule,
    StretchableTextModule,
    YoutubeModalModule,
    ImageAnimationModule,
    ButtonModule,
  ],
  exports:[],
  providers: [],
  bootstrap: [],
})
export class SitemuleSolutionsModule {}
